import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

export const useDateRangeQueryString = () => {
  const [params] = useSearchParams();

  // Fallback to window.location.search if useSearchParams returns empty start/end
  // This handles race conditions on fresh login where URL has params but React Router hasn't synced
  // This occurs because the login redirect sets URL params before React Router's state updates
  const sp =
    params.get('start') && params.get('end')
      ? params
      : new URLSearchParams(window.location.search);

  // Create stable 7-day range using useMemo (only calculated once on mount)
  // This prevents unnecessary re-renders when components use these values
  const sevenDayRange = useMemo(
    () => ({
      start: Math.floor(Date.now() / 1000) - 7 * 24 * 60 * 60,
      end: Math.floor(Date.now() / 1000),
    }),
    [], // Empty deps = only calculates once, like useRef but more semantic
  );

  return {
    start: Number(sp.get('start')),
    end: Number(sp.get('end')),
    cdate: sp.get('cdate') ?? 'false',
    sevenDayStart: sevenDayRange.start,
    sevenDayEnd: sevenDayRange.end,
  };
};
